<template>
  <div :class="`col-md-${width} form-group`">
    <label class="control-label" :for="name">{{ `${label} ${required ? '*' : ''}` }}</label>
    <select :ref="`select-${name}`" class="form-control" :id="name" :name="name" multiple @change="handleChange" :disabled="disabled" :required="required">
      <option v-for="(option, index) in options" :key="index" :value="option.value" :selected="selectedValues.includes(option.value)">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    name: String,
    label: String,
    options: { type: Array, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
  },
  computed: {
    selectedValues() {
      return Array.isArray(this.value) ? this.value : [];
    },
  },
  mounted() {
    this.initializeSelect2();
  },
  methods: {
    initializeSelect2() {
      const select = this.$refs[`select-${this.name}`];
      $(select).select2();
      $(select).on('change', this.handleChange);
      $(select)
        .val(this.value)
        .trigger('change');
    },
    handleChange(event) {
      const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
      this.$emit('input', selectedValues);
    },
  },
  watch: {
    options: {
      handler(newOptions) {
        this.$nextTick(() => {
          const select = this.$refs[`select-${this.name}`];
          $(select).empty();
          newOptions.forEach((option) => {
            $(select).append(new Option(option.label, option.value, this.selectedValues.includes(option.value)));
          });
          $(select).val(this.selectedValues);
        });
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/selectMultiple.vue